import { api, unwrap } from '../../api';

/**
 * `POST /v1/media/{id}/play` (bkfc-cms docs/routes/playback.md). `mediaId` is the v1 media id or
 * slug. `requestId` is the idempotency key of ONE user-initiated play: reuse it across retries of
 * that play, mint a new one for the next.
 * @returns {Promise<object>} the grant: grant_id, manifest_url, thumbnails_url,
 *   heartbeat_interval_s, is_preview, preview_duration_s, position_s, ...
 */
export const requestPlay = (mediaId, requestId) =>
  unwrap(
    api.POST('/v1/media/{id}/play', {
      params: { path: { id: mediaId } },
      body: {},
      idempotencyKey: requestId,
    }),
  ).then(body => body.data);

/** `PUT /v1/play/{grantId}/heartbeat` -> the ack, which carries the current interval. */
export const heartbeat = grantId =>
  unwrap(api.PUT('/v1/play/{grantId}/heartbeat', { params: { path: { grantId } } })).then(
    body => body.data,
  );

/**
 * `POST /v1/play/{grantId}/release`, keepalive so it survives the page going away. Best effort:
 * an unreleased grant lapses on its own after the heartbeat grace.
 */
export const release = grantId =>
  unwrap(
    api.POST('/v1/play/{grantId}/release', { params: { path: { grantId } }, keepalive: true }),
  ).catch(() => null);
